import ErrorBoundaryStore from './error-boundary-store';

let errorBoundaryStore: ErrorBoundaryStore | null = null;

const getErrorBoundaryStore = (): ErrorBoundaryStore => {
  if (errorBoundaryStore == null) {
    errorBoundaryStore = new ErrorBoundaryStore();
  }

  return errorBoundaryStore;
};

export { getErrorBoundaryStore };
